import { createDependencyInjectableComponent } from "@faire/retailer-visitor-shared/app/_lib/dependencyInjectableComponent";
import { useMaybePrefetchSearchPage } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/useMaybePrefetchSearchPage";
import React, { lazy } from "react";

export const LazySearchPageWithClientSidePrefetch: React.FC = () => {
  useMaybePrefetchSearchPage();
  const SearchPage = useSearchPage();
  return <SearchPage />;
};

export const LazySearchPageNoPrefetch = lazy(() =>
  import(
    /* webpackChunkName: "search-page" */ "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/SearchPage"
  ).then((m) => ({ default: m.SearchPage }))
);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
LazySearchPageNoPrefetch.preload = () =>
  import(
    /* webpackChunkName: "search-page" */ "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/SearchPage"
  ).then((m) => ({ default: m.SearchPage }));

const {
  useDependencyInjectableComponent: useSearchPage,
  DependencyInjectableComponentProvider: SearchPageProvider,
} = createDependencyInjectableComponent(LazySearchPageNoPrefetch);

export { SearchPageProvider };
